<template>
  <div class="overall-bg">
    <b-container fluid="xl">
      <b-row v-if="tstatus == true">
        <b-col>

          <BacktoPage path="/Masters" />
          <Headerlayout :headertext="$t('Items.ItemMaster.List')"
            :contenttext="$t('Items.ItemMaster.TableHeaderContent')">
          </Headerlayout>
        </b-col>
      </b-row>
      <b-row class="py-3">
        <b-col>
          <div v-if="windowWidth > 545">
            <SkeletonTableLoader :columns="headers" :loading="loading" />
            <div v-if="!loading">
              <MasterEmpty v-if="List.length === 0 && !loading && !SearchValue" eheader="Item Masters" econtent="Item"
                eimg="/src/assets/Img/icons/itemmaster.svg" @createNew="IsAdd" />

              <Tableview :value="List" v-if="List.length != 0 || SearchValue" :paginator="true"
                class="p-datatable-gridlines" :rows="10" :rowHover="true" filterDisplay="menu" :loading="loading1"
                responsiveLayout="scroll" :columns="headers" :globalFilterFields="globalFilterFields" :filters="filters"
                selectionMode="single" @row-click="RowClick" :exceldownload="true" :searchbox=false :searchbox1="true"
                @search="SearchOption">

                <template v-slot:Add>
                  <span class="add">
                    <AddButton @click="IsAdd" :btnname="$t('btn.plusaddnew')" class="float-rights my-3"></AddButton>
                  </span>
                </template>
                <template v-slot:exceldownload>
                  <ExportOption @ExportExcel="ExportExcel" @ExportPDF="ExportPDF" :ExportList="ExportList"
                    PageName="Item Master" :ExportOption="ExportOption" class="ms-2" :HideAndShow="true" />
                </template>
                <template v-slot:Status="{ data }">
                  <!-- <Badge v-if="data.IsActive == '0'" severity="warning">{{
                    "InActive"
                  }}</Badge>
                  <Badge v-if="data.IsActive == '1'" severity="success">{{
                    "Active"
                  }}</Badge> -->
                  <OrangeStatus name="InActive" v-if="data.IsActive == '0'" />
                  <GreenStatus name="Active" v-if="data.IsActive == '1'" />
                </template>
                <template v-slot:action="{ data }">
                  <span>
                    <Button icon="pi pi-ellipsis-v" class="p-button-rounded editicon p-button-text"
                      @click="toggle($event, data)" />
                  </span>
                </template>
              </Tableview>
            </div>
          </div>
          <div v-if="windowWidth <= 545">
            <MobileLoader v-if="loading" />
            <div v-if="!loading">
              <MasterEmpty v-if="List.length === 0 && !loading" eheader="Item Masters" econtent="Item"
                eimg="/src/assets/Img/icons/itemmaster.svg" @createNew="IsAdd" />
              <MobileViewCardHeader>
                <template v-slot:mobilecard>
                  <div class="mobile-card" v-for="item in List">
                    <div class="d-flex align-items-center justify-content-between gap-2">
                      <div>
                        <p class="light-name">{{ item.Code }}</p>
                        <div class="d-flex align-items-center gap-1">
                          <p class="name">{{ item.ItemName }}</p>
                        </div>
                      </div>
                      <div class="d-flex align-items-center">
                        <div>
                          <!-- <Badge v-if="item.IsActive == '1'" severity="success">{{ "Active" }}</Badge>
                          <Badge v-if="item.IsActive == '0'" severity="warning">{{ "InActive" }}</Badge> -->
                          <OrangeStatus name="InActive" v-if="item.IsActive == '0'" />
                          <GreenStatus name="Active" v-if="item.IsActive == '1'" />
                        </div>
                        <i class="pi pi-ellipsis-v" @click="toggle($event, item)"></i>
                      </div>
                    </div>
                  </div>
                </template>
              </MobileViewCardHeader>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>

    <Menu ref="menu" id="overlay_menu" :model="itemListed" @click="" :popup="true" />
    <EditConfirmation :Editmodel="Editmodel" @yes="IsEdit(dataEdit)" @no="Editmodel = false"
      :content="$t('confirmation.editcontent')" />
    <DeleteConfirmationVue :DeleteModel="Deletemodel" :content="content" @yes="IsDelete(dataEdit)"
      @no="Deletemodel = false" />
    <DeletedSuccessfully :visible="deletepop" @ok="closetrigger()" />
    <ActivatedSuccessfully :visible="popup.activatepop" @ok="closetrigger()" />
    <InActivatedSuccessfully :visible="popup.inactivepop" @ok="closetrigger()" />
    <Mapping :visible="MappingPop.visible" @ok="closetrigger()" :content="MappingPop.content" />

  </div>
  <Toast />
</template>

<script lang="ts">
import { defineComponent, ref, h, onMounted, computed, onUnmounted } from "vue";
import Headerlayout from "../../../../../../components/Masters/HeaderLayout.vue";
import BacktoPage from "../../../../../../components/FormComponents/BacktoMaster.vue";

import Itemcreation from "../../Items/ItemMaster/ItemCreation.vue";
import { RouterLink, RouterView, useRouter, useRoute } from "vue-router";
import axios from "axios";
import service from "../../../../Service/ItemMasService";
import StoreMasterService from "../../../../Service/StoreService";

import { FilterMatchMode, FilterOperator } from "primevue/api";
import Tableview from "../../../../../../components/FormComponents/Table.vue";
import { useI18n } from 'vue-i18n';
import EditConfirmation from "../../../../../../components/FormComponents/EditConfirmation.vue";
import DeleteConfirmationVue from "../../../../../../components/FormComponents/DeleteConfirmation.vue";
import DeletedSuccessfully from "../../../../../../components/FormComponents/DeletedSuccessfully.vue";
import MasterEmpty from "../../../../../../components/Masters/MasterEmpty.vue";
import Loader from "../../../../../../components/FormComponents/Loader.vue";
import ActivatedSuccessfully from "../../../../../../components/FormComponents/ActivateSuccessfully.vue";
import InActivatedSuccessfully from "../../../../../../components/FormComponents/InActivateSuccessfully.vue";
import Mapping from "../../../../../../components/FormComponents/Mapping.vue";

import MastersService from "../../../../Service/MastersService";
import { useToast } from "primevue/usetoast";
import { checkPermission } from "../../../../Service/AccessControl";
import SkeletonTableLoader from "../../../../../../components/FormComponents/SkeletonTableLoader.vue";
import MobileViewCardHeader from "../../../../../../components/FormComponents/MobileViewCardHeader.vue";
import MobileLoader from "../../../../../../components/SkeletonLoaderComponents/ContactCardView.vue";
import StoreMaster from "../../Stores/StoreMaster/StoreMaster";
import ExportOption from "../../../../../../components/FormComponents/Export.vue";
// import StoreDropDown from "../../../../modules/Inventory/components/DropDown/StoreDropDown.vue";
import debounce from 'lodash/debounce';


export default defineComponent({
  components: {
    BacktoPage,
    Headerlayout,
    Itemcreation,
    axios,

    Tableview,
    EditConfirmation,
    DeleteConfirmationVue,
    DeletedSuccessfully,
    MasterEmpty,
    Loader,
    ActivatedSuccessfully,
    InActivatedSuccessfully,
    SkeletonTableLoader,
    MobileViewCardHeader,
    MobileLoader,
    ExportOption,
    Mapping
  },

  props: {
    tstatus: {
      default: true,
      type: Boolean,
    },
  },
  setup() {
    debugger;

    const toast = useToast();
    const router = useRouter();
    const filter = "";
    const showmodalref = ref(false);
    let loading1 = ref(false);
    let loading = ref(false);
    let title = "Item Master";
    let List: any = ref([]);
    let CopyList: any = ref([]);
    const rowFocus = ref(false);
    const Editmodel = ref(false);
    const { t } = useI18n();
    const Deletemodel = ref(false);
    const deletepop = ref(false);
    const ObjData = ref();
    let content = ref("");
    const popup = ref({
      activatepop: false,
      inactivepop: false,
    });
    let ObjOperationId = ref({
      CreateId: 0,
      UpdateId: 0,
      ReadId: 0,
      DeleteId: 0,
    });

    const route = useRoute();
    const dataEdit = ref();
    const rowsCount = ref(0);

    let storeId = route.query.storeId;

    const windowWidth = ref(window.innerWidth);
    const handleResize = () => {
      windowWidth.value = window.innerWidth;
    };

    const headers = [
      {
        header: t('Items.ItemMaster.sno'),
        field: "RowNumber",
        class: "filterdisplaynone smallwidth",
      },
      {
        header: t('Items.ItemMaster.Code'),
        field: "ItemProductId",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
      },
      {
        header: t('Items.ItemMaster.Category'),
        field: "ItemCategoryName",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "mediumwidth",
        bodyclass: "text_overflow1",
      },
      {
        header: t('Items.ItemMaster.Group'),
        field: "ItemGroupName",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "mediumwidth",
        bodyclass: "text_overflow1",
      },
      {
        header: t('Items.ItemMaster.SubGroup'),
        field: "ItemSubGroupName",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "mediumwidth",
        bodyclass: "text_overflow1",
      },
      {
        header: t('Items.ItemMaster.Name'),
        field: "ItemName",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "boldclass text_overflow1",
        class: "mediumwidth",
      },
      {
        header: t('Items.ItemMaster.UOM'),
        field: "UnitName",

        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
      },
      {
        header: t('Items.ItemMaster.HSN'),
        field: "HSNCode",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "text_overflow1",
        class: "mediumwidth",
      },
      {
        header: t('Items.ItemMaster.Brand'),
        field: "BrandNames",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "mediumwidth",
        bodyclass: "text_overflow1",
      },
      {
        header: t('Items.ItemMaster.Model'),
        field: "ModelNames",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "mediumwidth",
        bodyclass: "text_overflow1",
      },
      {
        header: t('Items.ItemMaster.Size'),
        field: "Size",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "mediumwidth",
        bodyclass: "text_overflow1",
      },
      {
        header: t('Items.ItemMaster.AccountHead'),
        field: "AccountHeadName",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "mediumwidth",
        bodyclass: "text_overflow1",
      },
      {
        header: t('Items.ItemMaster.Cost'),
        field: "AvgLandingCost",
        class: "right-td smallwidth ",
        bodyclass: "right_td",
      },
      {
        header: t('Items.ItemMaster.MRP'),
        field: "MRP",
        class: "right-td smallwidth",
        bodyclass: "right_td",
      },
      {
        header: t('Items.ItemMaster.Manufacturer'),
        field: "ManufactureName",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "text_overflow1",
        class: "mediumwidth",
      },
      {
        header: t('Items.ItemMaster.Generic'),
        field: "ItemGenericName",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "text_overflow1",
        class: "mediumwidth",
      },
      {
        header: t('Items.ItemMaster.Status'),
        field: "ActiveStatus",
        fieldDisplay: "false",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "bluecolor",
        slot: "Status",
      },
      {
        header: "",
        field: "action",
        slot: "action",
        frozencolumn: true,
        sortable: false,
        class: "filterdisplaynone last-column-position",
        fieldDisplay: "false",
      },
    ];

    const filteredColumns = computed(() => {
      return headers.filter((col) => col.field !== "id");
    });

    const globalFilterFields = ref(headers.map((col) => col.field));

    const filters = {
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      Code: { value: null, matchMode: FilterMatchMode.IN, options: List },
      HSNName: { value: null, matchMode: FilterMatchMode.IN, options: List },
      ItemName: { value: null, matchMode: FilterMatchMode.IN, options: List },
      ManufactureName: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: List,
      },
      UnitName: { value: null, matchMode: FilterMatchMode.IN, options: List },
      ItemCategoryName: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: List,
      },
      ItemGroupName: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: List,
      },
      ItemSubGroupName: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: List,
      },
      ItemGenericName: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: List,
      },
      ActiveStatus: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: List,
      },
    };

    let ExportOption = ref("");
    let ExportList = ref([]);


    function ExportExcel() {
      debugger;
      ExportOption.value = "Excel";
      IsShowExport();
    }

    function ExportPDF() {
      debugger;
      ExportOption.value = "PDF";
      IsShowExport();
    }

    async function IsShowExport() {
      debugger;
      try {
        loading.value = false;
        let response: any;
        let count = 0;
        let arr = [];
        if (usersData.Admin == 1) {
          response = await service.getdata(usersData.OrganizationId);
          response["result"] = response["result"]
            .filter(
              (items) =>
                items.HospitalId == usersData.OrganizationId
            )
            .map((item) => {
              count = count + 1;
              item.RowNumber = count;
              item.ActiveStatus = item.IsActive == 1 ? "Active" : "Inactive";
              return item;
            });
          arr = response["result"];
        } else {


          let StoreResults = await StoreMasterService.StoreDropDownListByUserId(
            usersData.UserId,
            usersData.OrganizationId,
            usersData.Admin,
            usersData.BranchId
          );

          if (StoreResults["result"].length > 0) {
            const StoreId = Array.from(
              new Set(StoreResults["result"].map((item) => item.Id))
            ).join(",");

            response = await service.ListCustomByStoreId(StoreId, usersData.OrganizationId);
            response["result"] = response["result"]
              .map((item) => {
                count = count + 1;
                item.RowNumber = count;
                item.ActiveStatus = item.IsActive == 1 ? "Active" : "Inactive";
                return item;
              });
            arr = response["result"];
          }
        }

        ExportList.value = response["result"].map((item) => {
          const filteredItem = {};

          headers.forEach(({ header, field }) => {
            filteredItem[header] = item[field];
          });

          return filteredItem;
        });

        console.log("ContactTable Data", List.value);

        loading.value = false;
      } catch (error) {
        loading.value = false;
      }
    }

    const menu = ref();
    let InActivevisible = ref(false);
    let Activevisible = ref(false);
    let Editvisible = ref(false);

    const toggle = (event, data) => {
      debugger;
      ObjData.value = data;
      if (data.IsActive == 1) {
        Activevisible.value = false;
        InActivevisible.value = true;
        Editvisible.value = true;
      } else if (data.IsActive == 0) {
        Activevisible.value = true;
        InActivevisible.value = false;
        Editvisible.value = false;
      }
      menu.value.toggle(event);
    };

    const itemListed = ref([
      {
        items: [
          {
            label: "Edit",
            icon: "editicon pi pi-pencil",
            visible: Editvisible,
            command: async () => {
              IsConfirmEdit(ObjData);
            },
          },
          {
            label: "Delete",
            icon: "deleteicon pi pi-trash",
            visible: true,
            command: async () => {
              IsConfirmDel(ObjData, 0);
            },
          },

          {
            label: "Active",
            icon: "editicon pi pi-check-circle",
            visible: Activevisible,
            command: async () => {
              IsConfirmDel(ObjData, 1);
            },
          },
          {
            label: "InActive",
            icon: "deleteicon pi pi-minus-circle",
            visible: InActivevisible,
            command: async () => {
              IsConfirmDel(ObjData, 2);
            },
          },
        ],
      },
    ]);

    //get local storage session data
    let SessionUserData = localStorage.getItem("UsersData");
    let usersData;
    if (SessionUserData !== null) {
      usersData = JSON.parse(SessionUserData);
    }
    const MappingPop = ref({
      visible: false,
      content: "",
    });
    let SessionRolesData = localStorage.getItem("RolesData");
    let rolesData;
    if (SessionRolesData !== null) {
      rolesData = JSON.parse(SessionRolesData);
    }

    let SessionEntityData = localStorage.getItem("EntityData");
    let EntityData;
    if (SessionEntityData !== null) {
      EntityData = JSON.parse(SessionEntityData);
    }
    //

    onMounted(() => {
      window.addEventListener("resize", handleResize);
      document.addEventListener("keydown", onKeyUp);

      if (storeId) {
        itembasedonstore();
      } else {
        IsShow();
      }
      FunctionRights();
    });

    onUnmounted(() => {
      window.removeEventListener("resize", handleResize);
    });

    let Rights = ref({
      Create: false,
      Update: false,
      Read: false,
      Delete: false,
    });

    async function FunctionRights() {
      debugger;
      const response = await MastersService.CheckMenuRights(
        EntityData.EntityId,
        rolesData.RoleId
      );
      console.log(response["result"]);

      for (let i = 0; i < response["result"].length; i++) {
        const operation = response["result"][i];
        if (operation.OperationName === "Create") {
          ObjOperationId.value.CreateId = operation.OperationID;
          Rights.value.Create = operation.IsActive;
        } else if (operation.OperationName === "Update") {
          ObjOperationId.value.UpdateId = operation.OperationID;
          Rights.value.Update = operation.IsActive;
        } else if (operation.OperationName === "Read") {
          ObjOperationId.value.ReadId = operation.OperationID;
          Rights.value.Read = operation.IsActive;
        } else if (operation.OperationName === "Delete") {
          ObjOperationId.value.DeleteId = operation.OperationID;
          Rights.value.Delete = operation.IsActive;
        }
      }
    }

    function onKeyUp(event: any) {
      debugger;

      console.log(dataEdit.value);
      if (
        (event.key == "e" ||
          (Editmodel.value == false && event.key == "Enter")) &&
        rowFocus.value == true
      ) {
        Editmodel.value = true;
      } else if (event.altKey && event.key == "n") {
        IsAdd();
      } else if (
        (event.key == "y" || event.key == "Enter") &&
        Deletemodel.value == true &&
        Editmodel.value == false &&
        rowFocus.value == true
      ) {
        IsDelete(dataEdit.value);
      } else if (
        (event.key == "y" || event.key == "Enter") &&
        Editmodel.value == true &&
        rowFocus.value == true
      ) {
        IsEdit(dataEdit.value);
      } else if (
        event.key == "n" &&
        rowFocus.value == true &&
        Editmodel.value == true
      ) {
        Editmodel.value = false;
      } else if (event.key == "d" && rowFocus.value == true) {
        Deletemodel.value = true;
        Editmodel.value = false;
      } else if (
        event.key == "n" &&
        rowFocus.value == true &&
        Deletemodel.value == true
      ) {
        Deletemodel.value = false;
      } else if (event.key == "Escape" && deletepop.value == true) {
        deletepop.value = false;
      }
      else if (event.key == "Escape" && MappingPop.value.visible == true) {
        MappingPop.value.visible = false;
      } else if (event.key == "Enter" && rowFocus.value == false) {
        Editmodel.value = false;
      }
    }

    function RowClick(event: any) {
      rowFocus.value = true;
      dataEdit.value = event.data;

      router.push({
        path: "/ItemMasterDetails",
        query: { id: event.data.Id, itemcategoryId: event.data.ItemCategoryId },
      });
    }

    //Add New PopUp
    const IsAdd = () => {
      let permissionResult: any = checkPermission(Rights, "Add");
      if (permissionResult.hasPermission) {
        router.push({
          path: "/ItemMasterCreation",
          query: { OperationId: ObjOperationId.value.CreateId },
        });
      } else {
        toast.add(permissionResult.toast);
        return;
      }
    };

    function IsConfirmEdit(data) {
      debugger;

      let permissionResult: any = checkPermission(Rights, "Edit");
      if (permissionResult.hasPermission) {
        dataEdit.value = data;
        Editmodel.value = true;
      } else {
        toast.add(permissionResult.toast);
        return;
      }
    }

    function IsConfirmDel(data, status) {
      debugger;
      let permissionResult: any = checkPermission(Rights, "Delete");
      if (permissionResult.hasPermission) {
        dataEdit.value = data;
        Editmodel.value = false;
        Deletemodel.value = true;
        data.ActiveStatus = status;
        if (status == 1) {
          content.value = "Activate?";
        } else if (status == 2) {
          content.value = "InActivate?";
        } else {
          content.value = "Delete?";
        }
      } else {
        toast.add(permissionResult.toast);
        return;
      }
    }

    // Popup-Close
    function closetrigger() {
      deletepop.value = false;
      popup.value.activatepop = false;
      popup.value.inactivepop = false;
      MappingPop.value.visible = false;
    }

    //Table List
    async function IsShow() {
      debugger;
      loading.value = true;
      let response: any;
      let count = 0;
      let arr = [];
      try {
        if (usersData.Admin == 1) {
          response = await service.getdata(usersData.OrganizationId);
          response["result"] = response["result"]
            .map((item) => {
              count = count + 1;
              item.RowNumber = count;
              item.ActiveStatus = item.IsActive == 1 ? "Active" : "Inactive";
              return item;
            });
          arr = response["result"];
        } else {

          let StoreResults = await StoreMasterService.StoreDropDownListByUserId(
            usersData.UserId,
            usersData.OrganizationId,
            usersData.Admin,
            usersData.BranchId
          );

          if (StoreResults["result"].length > 0) {
            const StoreId = Array.from(
              new Set(StoreResults["result"].map((item) => item.Id))
            ).join(",");

            response = await service.ListCustomByStoreId(StoreId, usersData.OrganizationId);
            response["result"] = response["result"]
              .map((item) => {
                count = count + 1;
                item.RowNumber = count;
                item.ActiveStatus = item.IsActive == 1 ? "Active" : "Inactive";
                return item;
              });
            arr = response["result"];
          }
        }

        List.value = arr;
        CopyList.value = arr;

        console.log(List.value);
        loading.value = false;
      } catch (error) {
        alert(error);
      }
    }

    let SearchValue = ref();
    const debouncedSearch = debounce((input) => {
      let regex = new RegExp(input, "i");

      List.value = CopyList.value.filter((item) => {
        return Object.values(item).some(value => regex.test(String(value)));
      });
    }, 300); // Adjust the delay as needed

    function SearchOption(Input) {
      debugger;
      SearchValue.value = Input;
      debouncedSearch(SearchValue.value);
    }

    async function itembasedonstore() {
      try {
        // alert(route.query.storeId)
        loading.value = true;
        const result = await service.ListItemByStoreId(route.query.storeId,
          usersData.BranchId,
          usersData.OrganizationId,
        );
        debugger;
        console.log(result);
        List.value = result["result"];
        if (result["result"].length > 0) {
          rowsCount.value = result["result"].length;
        }
        console.log(List.value);
        loading.value = false;
      } catch (error) {
        console.log(error);
      }
    }

    //Edit Click function
    async function IsEdit(data) {
      debugger;
      router.push({
        path: "/ItemMasterCreation",
        query: {
          id: data.value.Id,
          OperationId: ObjOperationId.value.UpdateId,
        },
      });
    }

    //Row Delete
    async function IsDelete(data) {
      debugger;
      loading.value = true;
      const DelID = data.value.Id;
      try {
        let data_response: any = "";
        if (data.ActiveStatus == 0) {
          data_response = await service.Delete(DelID);
        } else {
          let status = data.ActiveStatus == 1 ? true : false;
          data_response = await service.active(DelID, status);
        }
        console.log(data_response);
        let message = data_response["ErrorInfo"].ErrorCode;
        loading.value = false;
        if (data_response["result"] != "False" && message == null) {
          Deletemodel.value = false;
          MappingPop.value.content = data_response["result"];
          MappingPop.value.visible = true;
        }
        else if (message == null) {
          if (data.ActiveStatus == 1) {
            loading.value = false;
            popup.value.activatepop = true;
          } else if (data.ActiveStatus == 2) {
            loading.value = false;
            popup.value.inactivepop = true;
          } else {
            loading.value = false;
            deletepop.value = true;
          }
          deletepop.value = true;
          Deletemodel.value = false;
          rowFocus.value = false;
          IsShow();
        }
      } catch (error) {
        loading.value = false;
        alert(error);
      }
    }

    return {
      title,
      headers,
      filter,
      showmodalref,
      showpopModal: showmodalref,
      loading1,
      List,
      IsDelete,
      filters,
      globalFilterFields,
      filteredColumns,
      IsShow,
      IsEdit,
      RowClick,
      dataEdit,
      Editmodel,
      IsAdd,
      onKeyUp,
      IsConfirmEdit,
      IsConfirmDel,
      Deletemodel,
      closetrigger,
      deletepop,
      loading,
      popup,
      menu,
      content,
      itemListed,
      toggle,
      windowWidth,
      ExportExcel,
      ExportOption,
      ExportPDF,
      ExportList,
      MappingPop,
      SearchOption,
      SearchValue
    };
  },
});
</script>
<style lang="scss" scoped>
.mobilestorename {
  font-size: 16px;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  margin-top: -7px;
}

.mobilestorelightname {
  font-size: 14px;
  color: #999999;
}
</style>
